import React, { useState, useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Constant from "../Components/Utils/Constant";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

export default function EditModalUser ({ user, onClose, setEditData })  {
    const [subscription, setSubscription] = useState("");
    const [videos, setVideos] = useState([]);
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(true);

    
    useEffect(() => {
        setSubscription(user.subscription);
    }, [user]);

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const response = await axios.get(`${Constant.BASE_URL}/subscription/get`);
                setVideos(response.data.subscription);
            } catch (error) {
                console.error("Error fetching subscription plans:", error);
            }
        };
        fetchVideos();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedUser = {
                email: user.email,
                subscription,
                subscriptionexpiry: false,
            };
            await axios.put(
                `${Constant.BASE_URL}/user/updatebyid`,
                updatedUser
            );
            setEditData(updatedUser);
            setEditData(false);
          // fetchSubscription();
          toast.success("User Updated successfully");
          handleClose();
          setTimeout(() => {
              handleClose();

          }, 3000);
        } catch (error) {
            console.error("Error updating user:", error);
        }
    };
    const handleClose = () => {
        setIsVisible(false);
        onClose();
    };

    return isVisible ? (
        <>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="popup-formmodel w-[400px]">
            <div className="bg-white rounded-lg shadow-lg p-6 relative">
                <div className="flex justify-center items-center mb-4">
                    <h2 className="text-lg font-semibold text-center">USER Subscription Plan</h2>
                   
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="my-8">
                        <label htmlFor="subscription" className="block text-sm font-medium text-gray-700 mb-2">
                            Subscription Plan
                        </label>
                        <select
                            id="subscription"
                            className="py-2 block w-full mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            required
                            name="subscription"
                            value={subscription}
                            onChange={(e) => setSubscription(e.target.value)}
                        >
                            <option>Select Plan</option>
                            {videos &&
                                videos.map((client) => (
                                    <option key={client._id} value={client.planevalidity}>
                                        {`Plan: ${client.planname} - Duration: ${client.planevalidity} days - Price: ${client.price}`}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className="flex justify-center gap-10 text-center mt-6">
                    <button onClick={handleClose} type="" className="inline-flex items-center px-8 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Cancel
                        </button>
                        <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Activate Plan
                        </button>

                    </div>
                </form>
            </div>
        </div>
        </>
    ) : null;
}
